import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/registry.scss';

export class DirectoryRegistry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      id: null,
      name: '',
      type: '',
      parent_directory_id: null
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    let params = {
      action: 'saveDirectory',
      token: sessionStorage.getItem('token'),
      name: this.state.name,
      parent_directory_id: this.state.parent_directory_id,
      type: this.state.type
    };

    // set id if exists
    if (this.state.id != null && this.state.id != '') {
      params['id'] = this.state.id;
    }

    let response = await window.doRequest('POST', params);

    if (response.status)
      this.props.history.push('/directory/' + this.state.parent_directory_id);
    else
      window.alert(response.message);
  }

  async verifyIfHasPrivileges(parentDirectoryId) {
    let response = await window.doRequest('GET', {
      action: 'hasPrivileges',
      token: sessionStorage.getItem('token'),
      id: parentDirectoryId,
      privilege_type: 'edit'
    });

    if (response.status)
      this.setState({
        loading: false,
        parent_directory_id: parentDirectoryId
      })
    else
      window.alert(response.message);
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    const dir_info = this.props.location.dir_info;
    if (dir_info != null) {
      this.setState({
        id: dir_info.id,
        name: dir_info.name,
        type: (dir_info.type != null ? dir_info.type : '')
      })
    }

    let url = window.location;
    let parentDirectoryId = /[^/]*$/.exec(url)[0];

    this.verifyIfHasPrivileges(parentDirectoryId);
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="registry">
          <div className="container">
            {
              this.state.loading
                ? <Loader />
                : <div className="directory-registry">
                    <h1 className="title">Registro de pasta</h1>
                    {
                      (this.state.parent_directory_id != null)
                        ? <div className="back-btn-container">
                            <button className="back-btn" onClick={(e) => {
                              this.props.history.push('/directory/' + this.state.parent_directory_id)
                            }}>
                              Voltar
                            </button>
                          </div>
                        : null
                    }

                    <p>Preencha os dados abaixo.</p>
                    <form onSubmit={(e) => { this.formSubmit(e) }}>

                      <input
                        type="text"
                        placeholder="Nome da pasta"
                        name="name"
                        value={this.state.name}
                        onChange={(e) => {this.handleChange(e)}}
                        required>
                      </input>

                      <select value={this.state.type} name="type" onChange={(e) => {this.handleChange(e)}}>
                        <option value="">Selecione o tipo de visualização (opcional)</option>
                        <option value="search">Lista de arquivos com barra de pesquisa</option>
                        <option value="gallery">Galeria de imagens ou vídeos</option>
                        <option value="expanded">Conteúdo expandido (visualização de subpastas)</option>
                        <option value="team">Específica para pasta Interlocutores e Equipe</option>
                      </select>

                      <div className="btn-container">
                        <button className="btn filled" type="submit">Salvar</button>
                      </div>

                    </form>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default DirectoryRegistry
